import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';  
import { MobileHeaderComponent } from '../../components/mobile-header/mobile-header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { SidebarUserComponent } from "../../components/sidebar-user/sidebar-user.component";
import { environment } from '../../../environments/environment';
import { getCookie } from '../../utils/getCookies';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { LanguageSwitcherComponent } from '../../components/language-switcher/language-switcher.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalPingLinkedinComponent } from './modals/modal-ping-linkedin/modal-ping-linkedin.component';
@Component({
  host: { class: 'conectio-brand' },
  selector: 'app-candidate-profiling-success',
  standalone: true,
  imports: [LanguageSwitcherComponent, MatButtonModule, SidebarComponent, MobileHeaderComponent, FooterComponent, CommonModule, SidebarUserComponent, TranslateModule],
  templateUrl: './candidate-profiling-success.component.html',
  styleUrl: './candidate-profiling-success.component.scss'
})
  export class CandidateProfilingSuccessComponent {
  isLinkedInScriptLoaded: boolean = false;
  hasOffer: boolean = false;
  offername: string = '';
  readonly linkedinUrl = 'https://www.linkedin.com/company/conectiodigital/';

  // WhatsApp chat with the message already written in the candidate's language
  whatsappUrl(message: string): string {
    return 'https://wa.me/34644723402?text=' + encodeURIComponent(message);
  }

  constructor(private router: Router, private http: HttpClient, public dialog: MatDialog) {
    document.cookie = "manualStep=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "current_step=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    if (getCookie('offer')) {
      this.checkHasOffer();
    }
  }

  get firstName(): string {
    return (getCookie('name') || '').split(' ')[0];
  }


  navigateToDashboard() {
    this.router.navigate(['/dashboard/user']);
  }

  checkHasOffer() {
    const accessToken = getCookie('access_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });
    this.http.get(`${environment.url}/api/v1/user/has_offer`, { headers }).subscribe((response: any) => {
      this.hasOffer = response.has_offer;
      this.offername = response.offer_name ?? "";
    });
  }

  openModalPingLinkedin() {
    this.dialog.open(ModalPingLinkedinComponent, {
      panelClass: 'conectio-brand',
      data: {},
      width: '400px',
      height: '448px'
    });
  }

}
